// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_nd-0";
export var discountCodeInput = "_nd-1";